/* Shared utility to append whs param for OTC sales channels.
    Only appends when:
    - isOtc is true
    - whs is one of '1','2','3'
    - url does not already contain a whs param
*/
export function buildOtcHref(url, { isOtc, whs }) {
    if (!url || !isOtc || whs === null) return url;

    const whsStr = String(whs);
    if (!['1', '2', '3'].includes(whsStr)) return url;

    // Separate hash fragment (if any) so we always append query before it (not used in category navigation but added for future-proofing).
    const [basePlusQuery, hashFragment] = url.split('#');

    // If whs already present in query, return original untouched
    if (/[?&]whs=/.test(basePlusQuery)) return url;

    const sep = basePlusQuery.includes('?') ? '&' : '?';
    const newUrl = `${basePlusQuery}${sep}whs=${encodeURIComponent(whsStr)}`;
    return hashFragment ? `${newUrl}#${hashFragment}` : newUrl;
}

// enrichOtcUrl pulls isOtc & whs from the Vuex store getters
// While keeping buildOtcHref pure.
export function enrichOtcUrl(url, store) {
    if (!store) return url;
    const isOtc = store.getters && store.getters['core/isOTCSalesChannel'];
    const whs = store.getters && store.getters['plpFilters/activeWhs'];
    return buildOtcHref(url, { isOtc, whs });
}
